import { JobInterview } from "src/types";
import { InterviewClass } from "./interview";
export class JobInterviewClass {
  interview: JobInterview;
  Interview: InterviewClass;

  constructor(data: JobInterview) {
    this.interview = data;
    this.Interview = new InterviewClass(data.Interview);
  }

  getResumeFileName() {
    const { first_name, resume_presigned } = this.interview;
    if (!resume_presigned) return "";
    // Remove query params if they are there
    const link = resume_presigned.split("?")[0];
    const split = link.split(".");
    const ext = split[split.length - 1];
    return `${first_name || ""}_resume.${ext}`;
  }

  getParsedFeedback() {
    return this.Interview.getParsedFeedback();
  }

  interviewDurationText() {
    const { Videos } = this.interview;
    if (!Videos?.[0]) return "";

    const start = new Date(Videos[0]?.duration_range[0].value);
    const end = new Date(Videos[Videos.length - 1]?.duration_range[1].value);
    const minutes = Math.floor((end.getTime() - start.getTime()) / (1000 * 60));
    if (minutes <= 0) return "";

    return `${minutes} Minutes`;
  }
}
